import type { AuthSession } from "@/features/auth/lib/auth-store";

/** Till debit: ADMIN, or STAFF with BONUS_REDEMPTION. Missing/wrong tag is view-only. */
export function canRedeem(session: AuthSession | null): boolean {
	if (!session) {
		return false;
	}
	if (session.role === "ADMIN") {
		return true;
	}
	return session.role === "STAFF" && session.tags.includes("BONUS_REDEMPTION");
}
